// 顶部入口条（EP-004-S2）—— 左「包裹」+ 未读角标、中完成度（无数字文案，B1）、右「设置」。
// 老板 2026-09-15 反馈两个按钮点了没反应 → 现都接通。
// away 态也渲染（见 MainView）。
// 老板 2026-09 文案改名：「空间」→「包裹」（P6-POLISH-ENG-001）。
//   仅改用户可见文案；代码标识符（view: 'space' / spaceTab / SpaceView）保持原样。
//
// 🆕 v2.1：包裹按钮 badge = 未读礼物数 + 未读明信片数（合计）。
// 由 MainView 通过 totalUnread prop 注入；礼物/明信片各自独立追踪 isRead。
interface TopBarProps {
  progressText: string;
  totalUnread: number; // 🆕 v2.1：未读礼物 + 未读明信片合计数
  onOpenSpace: () => void;
  onOpenSettings: () => void;
}

export function TopBar({ progressText, totalUnread, onOpenSpace, onOpenSettings }: TopBarProps) {
  return (
    <div className="top-bar">
      <button
        type="button"
        className="top-bar__space"
        onClick={onOpenSpace}
        aria-label={`进入包裹，查看已收集的礼物${totalUnread > 0 ? `，有 ${totalUnread} 件未读` : ''}`}
      >
        包裹
        {totalUnread > 0 && (
          <span className="top-bar__badge" aria-hidden="true">
            {totalUnread}
          </span>
        )}
      </button>
      {/* 🆕 P6-POLISH-ENG-002（07 §D.4）：aria-label 由「已收集状态」改为「礼物收集进度」——
          原来没说清这是**礼物**的进度（明信片是另一套），读屏用户会混淆。 */}
      <span className="top-bar__progress" aria-label={`礼物收集进度：${progressText}`}>
        {progressText}
      </span>
      <button
        type="button"
        className="top-bar__settings"
        onClick={onOpenSettings}
        aria-label="打开设置"
      >
        设置
      </button>
    </div>
  );
}
